import { Theme } from '../../Theme';

export class ThemePersistenceMapper {
  public static toDto = (theme: Theme): SimpleProjectServiceAPI.ThemeDto => ({
    primaryColor: theme.config_ral_primary,
    secondaryColor: theme.config_ral_secondary
  });

  public static toDomain = (dto: SimpleProjectServiceAPI.ThemeDto): Theme => ({
    config_ral_primary: dto.primaryColor,
    config_ral_secondary: dto.secondaryColor
  });
}
